import {
  eventDetailsServingType as commonEventDetailsServingType,
  occasionEventStyle,
  occasionFoodServiceTime,
  occasionOnsiteFacilities,
  occasionRequirements,
  occasionServiceStyle,
  occasionStaffServiceTime,
} from '../common'
import { DropdownType, OccasionFieldsAndEventDetails, TextType } from '../types'
import { match } from 'ts-pattern'

// Dropdown

const occasionEventType: DropdownType = {
  id: 'eventType',
  label: 'What type of event?',
  type: 'dropdown',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Corporate Function/Event',
      value: 'CORPORATE_FUNCTION_EVENT',
    },
    {
      label: 'Office Celebration',
      value: 'OFFICE_CELEBRATION',
    },
    {
      label: 'Cultural Event/Themed Day',
      value: 'CULTURAL_EVENT_THEMED_DAY',
    },
  ],
}

const occasionEventTypeOfficeCelebration: DropdownType = {
  id: 'eventTypeOfficeCelebration',
  label: undefined,
  type: 'dropdown',
  needs: [
    {
      id: 'eventType',
      value: 'OFFICE_CELEBRATION',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Birthday',
      value: 'BIRTHDAY',
    },
    {
      label: 'Retirement',
      value: 'RETIREMENT',
    },
    {
      label: 'Anniversary',
      value: 'ANNIVERSARY',
    },
    {
      label: 'Company milestone',
      value: 'COMPANY_MILESTONE',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ],
}

const occasionEventTypeCultural: DropdownType = {
  id: 'eventTypeCultural',
  label: undefined,
  type: 'dropdown',
  needs: [
    {
      id: 'eventType',
      value: 'CULTURAL_EVENT_THEMED_DAY',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Pancake Day',
      value: 'PANCAKE_DAY',
    },
    {
      label: "International Women's Day",
      value: 'INTERNATIONAL_WOMENS_DAY',
    },
    {
      label: 'Pride',
      value: 'PRIDE',
    },
    {
      label: 'Black History Month',
      value: 'BLACK_HISTORY_MONTH',
    },
    {
      label: 'Halloween',
      value: 'HALLOWEEN',
    },
    {
      label: 'Diwali',
      value: 'DIWALI',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ],
}

// Text Fields

const occasionEventTypeOther: TextType = {
  id: 'eventTypeOther',
  label: undefined,
  inputLabel: 'What is the occasion?',
  type: 'text',
  needs: [
    {
      id: 'eventTypeOfficeCelebration',
      value: 'OTHER',
    },
    {
      id: 'eventTypeCultural',
      value: 'OTHER',
    },
  ],
  prefill: false,
}

export const occasions = (code: string): OccasionFieldsAndEventDetails => {
  const result: OccasionFieldsAndEventDetails = {
    skip: false,
    fields: [],
    eventDetails: [],
  }
  match(code)
    .with('BREAKFAST', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('MORNING_TEA', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('LUNCH', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('AFTERNOON_TEA', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('DINNER', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('EVENT_OTHER', () => {
      result.fields.push(
        occasionEventType,
        occasionEventTypeOfficeCelebration,
        occasionEventTypeCultural,
        occasionEventTypeOther,
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(commonEventDetailsServingType)
    })

  return result
}
